import { API_REQUEST, GET_SNAPSHOTS_LIST, DOWNLOAD_POI_REPORT, GET_POI_VIEW_DATA, RESET_SNAPSHOTS_LIST, POI_CUD, GET_SNAPSHOT, RESET_SNAPSHOT, GET_SNAPSHOTS_LIST_SILENT, ADD_NEW_POI, REM_NEW_POI} from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

export const getPOIList = (userId: string, rollNum: string, ownerType: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/snapshots/${userId}/${rollNum}/${ownerType}`,
        next: GET_SNAPSHOTS_LIST,
        method: 'GET',
        authorization: true
    }
});

interface POIPayload extends Record<string, unknown> {
    "user": string;
    "lang": string;
    "roll": string;
    "pois": string;
    "new_pois": string;
    "is_pdf": boolean;
}

export const downloadPOIReport = (payload: POIPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/download`,
        next: DOWNLOAD_POI_REPORT,
        method: 'POST',
        data: payload,
        authorization: true
    }
});

export const getPOIViewData = (payload: POIPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/getviewdata`,
        next: GET_POI_VIEW_DATA,
        method: 'POST',
        data: payload,
        authorization: true
    }
});

export const removePOI = (user_profile_id: string, parent_roll: string, snap_roll: string, ownerType: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/remove/${user_profile_id}/${parent_roll}/${snap_roll}/${ownerType}`,
        next: POI_CUD,
        method: 'DELETE',
        authorization: true
    }
});

export const addPOI = (user_profile_id: string, parent_roll: string, snap_roll: string, ownerType: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/add/${user_profile_id}/${parent_roll}/${snap_roll}/${ownerType}`,
        next: POI_CUD,
        method: 'PUT',
        authorization: true
    }
});

export const getPOIListNoloading = (userId: string, rollNum: string, ownerType: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/snapshots/${userId}/${rollNum}/${ownerType}`,
        next: GET_SNAPSHOTS_LIST_SILENT,
        method: 'GET',
        authorization: true,
    }
});

export const resetgetPOIList = (): AppNoApiAction => ({
    type: RESET_SNAPSHOTS_LIST
});


export const getSnapShot = (userId: string, rollNum: string, snapRoll: string, onwer: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/poi/snapshot/${userId}/${rollNum}/${snapRoll}/${onwer}`,
        next: GET_SNAPSHOT,
        method: 'POST',
        authorization: true,
    }
});

export const getSnapshotWithCaptcha = (userId: string, rollNum: string, snapRoll: string, onwer: string, captcha: string): AppAction => {
    const data = getSnapShot(userId, rollNum, snapRoll, onwer);
    data["payload"]["data"] = {
        "g-recaptcha-response" : captcha
    }
    return data
};


export const resetgetSnapShot = (): AppNoApiAction => ({
    type: RESET_SNAPSHOT
});


export const addNewPoi = (roll: string): AppNoApiAction => ({
    type: ADD_NEW_POI,
    data: roll
})

export const removeNewPoi = (roll: string): AppNoApiAction => ({
    type: REM_NEW_POI,
    data: roll
})